import * as React from 'react';

interface GridLayerProps {
    worldSize: { w: number; h: number } | null;
    gridSize: number;
    showGrid: boolean;
}

const GridLayer: React.FC<GridLayerProps> = ({ worldSize, gridSize, showGrid }) => {
    if (!worldSize || !showGrid) return null;

    return (
        <svg
            className="absolute inset-0 pointer-events-none"
            width={worldSize.w}
            height={worldSize.h}
        >
            <defs>
                <pattern
                    id="grid"
                    width={gridSize}
                    height={gridSize}
                    patternUnits="userSpaceOnUse"
                >
                    <circle cx="1" cy="1" r="1.5" fill="rgba(255,255,255,0.5)" />
                    <circle cx="1" cy="1" r="0.75" fill="rgba(0,0,0,0.3)" />
                </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
    );
};

export default React.memo(GridLayer);
